import { computed, ref, watch, type ComputedRef, type Ref } from 'vue'

export interface UseFormDirtyReturn {
  /** Le formulaire diffère de l'état de référence */
  dirty: ComputedRef<boolean>
  /** Prend l'état courant comme référence (après chargement ou enregistrement) */
  markClean: () => void
}

function serialize(value: unknown): string {
  try {
    return JSON.stringify(value ?? null)
  } catch {
    return ''
  }
}

/**
 * Suivi des modifications non enregistrées d'un formulaire (prop `dirty` de `KsEditPage`).
 *
 * La référence est prise à la création, puis à chaque fin de chargement quand `loading` est fourni
 * (`useEntityDetailView` recharge après l'enregistrement : la page redevient « propre »).
 * Candidat à remonter dans KStone à côté de `KsEditPage`.
 */
export function useFormDirty(form: Ref<unknown>, loading?: Ref<boolean>): UseFormDirtyReturn {
  const reference = ref(serialize(form.value))

  function markClean() {
    reference.value = serialize(form.value)
  }

  if (loading) watch(loading, isLoading => { if (!isLoading) markClean() })

  const dirty = computed(() => serialize(form.value) !== reference.value)
  return { dirty, markClean }
}
